import styled, { css } from 'styled-components';

import animations from '../../../../assets/styled/animations';
import { dropdownTokens } from '../../../../tokens/components/Dropdown/tokens';

import { inputWidths } from '../../../_common/Controller/styles';
import { DropdownHeaderWrapper } from '../DropdownHeader/DropdownHeader';
import DropdownAura from '../DropdownAura/DropdownAura';

export const DropdownBox = styled.ul<{ ref: any }>`
  animation: ${animations.slideDown} 150ms ease-out forwards;
  background-color: ${dropdownTokens.ContainerBackgroundColorBaseDefault};
  border-radius: ${dropdownTokens.ContainerBorderRadiusBaseDefault};
  border-width: ${dropdownTokens.ContainerBorderWidthBaseDefault};
  border-style: ${dropdownTokens.ContainerBorderStyleBaseDefault};
  border-color: ${dropdownTokens.ContainerBorderColorBaseDefault};
  box-shadow: ${dropdownTokens.ContainerShadowOffsetXBaseDefault} ${dropdownTokens.ContainerShadowOffsetYBaseDefault}
    ${dropdownTokens.ContainerShadowBlurBaseDefault} ${dropdownTokens.ContainerShadowSpreadBaseDefault}
    ${dropdownTokens.ContainerShadowColorBaseDefault};
  margin: ${dropdownTokens.ContainerSpacingOuterVerticalBaseDefault}
    ${dropdownTokens.ContainerSpacingOuterHorizontalBaseDefault};
  // Design context for width styling: https://carta1.atlassian.net/browse/INK-512
  // If no width override is passed, use max-content
  width: ${({ theme }) => theme.dropdownWidth ?? 'max-content'};
  // If width override is passed, don't set min-width. Otherwise, use min-width token
  min-width: ${({ theme }) => (theme.dropdownWidth ? 'auto' : dropdownTokens.BoxDimensionsMaxWidthMinimum)};
  // If width override is passed, don't set max-width. Otherwise, use appropriate max-width
  max-width: ${({ theme }) =>
    theme.dropdownWidth
      ? 'none'
      : `clamp(
      ${dropdownTokens.BoxDimensionsMaxWidthMinimum},
      ${dropdownTokens.BoxDimensionsMaxWidthFlexible},
      ${dropdownTokens.BoxDimensionsMaxWidthMaximum}
    )`};
  padding: ${dropdownTokens.ContainerSpacingInnerVerticalBaseDefault}
    ${dropdownTokens.ContainerSpacingInnerHorizontalBaseDefault};
  position: absolute;
  top: 100%;
  z-index: ${dropdownTokens.ContainerElevationBaseDefault};

  /* TODO: Consider tokenization later */
  ${({ theme }) =>
    theme.dropdownIsTypeahead &&
    !theme.cellPreset &&
    css`
      // By default, the dropdown box is as wide as the input for size large and above.
      // A custom width, when present, overrides the default.
      width: ${theme.dropdownWidth ? theme.dropdownWidth : inputWidths[theme.inputWidth || 'full']};
      max-width: none;
    `}

  ${({ theme }) => {
    return (
      theme.dropdownIsTypeahead &&
      theme.cellPreset &&
      css`
        // When inside a table, the dropdown box is at least as wide as its containing cell.
        // A custom width, when present, overrides the default
        min-width: ${theme.dropdownWidth ? theme.dropdownWidth : '100%'};
      `
    );
  }}

  /* Dynamically set "left: 0px" or "right: 0px" */
  ${({ theme }) => `${theme.dropdownAlign}: 0px;`}

  /* Scrollable Style */
  ${({ theme }) =>
    theme.dropdownScrollable &&
    `
      max-height: 50vh;
      overflow: auto;
  `}

  /* Dropdown Height */
  ${({ theme }) =>
    theme.dropdownMaxHeight &&
    `
      max-height: ${theme.dropdownMaxHeight};
      overflow: auto;
  `}

  /* Scroll Table Style */
  ${({ theme }) =>
    theme.dropdownScrollTable &&
    `
      margin-top: 30px;
      right: 4px;
      top: auto;
  `}

  /* Use smaller spacing for first header in dropdown */
  ${DropdownAura}:first-of-type ${DropdownHeaderWrapper} {
    margin-top: 8px;
  }
`;

DropdownBox.displayName = 'Dropdown.Box';

export default DropdownBox;
